import { render, staticRenderFns } from "./VehicleFleet.vue?vue&type=template&id=6ca5192c&"
import script from "./VehicleFleet.vue?vue&type=script&lang=ts&"
export * from "./VehicleFleet.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports